
import React, { Component } from 'react'
import { Row, Col, Button, Tabs, message } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCookie } from '../../hook';
import $ from 'jquery';
import './style.css';

// Child Component
import About from './childs/about';
import Summary from './childs/summary';
import RequestSummary from './childs/requests';

// Actions
import { 
    get_summary_annual_leave, 
    get_employee, 
    get_department, 
    get_employee_list, 
    get_designation, 
    get_company, 
    update_employee, 
    upload_files,
    get_request_summary } from './actions/selfservice.action';


const TabPane = Tabs.TabPane;
class Profile extends Component {

    constructor( props ){
        super( props );

        this.state = {
            profile: 'data:image/png;base64,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',
            data: [],
            department_data: [],
            employee_data: [],
            designation_data: [],
            company_data: [],
            summary_data: [],
            request_data: []
        }

        this.handleTabs = this.handleTabs.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this ); 
        this.handleProfilePic = this.handleProfilePic.bind( this );
    }

    handleProfilePic( e ){
        var fdata = new FormData();
        let user = getCookie('dv_hrms_user').split(',');
        var user_id =  user[1];

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "user_id", user_id );

            });
        }

        this.props.upload_files( fdata );
    }

    componentWillMount(){

        let user = getCookie('dv_hrms_user').split(',');

        // this.props.get_employee( user[1] );
        // this.props.get_department();
        // this.props.get_employee_list();
        // this.props.get_designation();
        // this.props.get_company();

        this.props.get_summary_annual_leave( user[1] );
        this.props.get_request_summary( user[6] );
    
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.summary.length !== 0 ){

            if( nextProps.summary.STATUS.CODE === "200" &&
                nextProps.summary.STATUS.MESSAGE === "Successfully Listed Annual Leaves Summary" ){
                
                this.setState({
                    summary_data: nextProps.summary.OUTPUT.DATA
                });

            }

            if( nextProps.summary.STATUS.CODE === "200" &&
                nextProps.summary.STATUS.MESSAGE === "Successfully listed request summary" ){

                this.setState({
                    request_data: nextProps.summary.OUTPUT.DATA
                });

            }

        }

        if( nextProps.employeeedit.length !== 0 ){

            if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "Successfully Listed Employee Edit" ) {
                this.setState({
                    data: nextProps.employeeedit.OUTPUT.DATA
                });

            } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "Get Department" ) {
                this.setState({
                    department_data: nextProps.employeeedit.OUTPUT.DATA
                });

            } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "Get Employee List" ) {
                this.setState({
                    employee_data: nextProps.employeeedit.OUTPUT.DATA
                });

            } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "Get Designation" ) {
                this.setState({
                    designation_data: nextProps.employeeedit.OUTPUT.DATA
                });

            } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "Get Company" ) {
                this.setState({
                    company_data: nextProps.employeeedit.OUTPUT.DATA
                });

            } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "Successfully Updated Employee Edit" ) {

                message.success('Successfully Updated');
                
                let user = getCookie('dv_hrms_user').split(',');

                this.props.get_employee( user[1] );
                this.props.get_department();
                this.props.get_employee_list();
                this.props.get_designation();
                this.props.get_company();
            
            } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
                nextProps.employeeedit.STATUS.MESSAGE === "File Uploaded" ) {
                
                message.success('Profile Picture seted');
                
                let user = getCookie('dv_hrms_user').split(',');

                this.props.get_employee( user[1] );
                this.props.get_department();
                this.props.get_employee_list();
                this.props.get_designation();
                this.props.get_company();

            } else if( nextProps.employeeedit.STATUS.CODE === "400" ) {

                if( nextProps.employeeedit.STATUS.MESSAGE !== 'Error: 0 results' ){
                    message.error( nextProps.employeeedit.STATUS.MESSAGE );
                }
            }


        }

    }

    handleSubmit( data ){

        let user = getCookie('dv_hrms_user').split(',');

        this.props.update_employee( user[1] , data )
    }

    handleTabs( key ){

        let self = this;
        let user = getCookie('dv_hrms_user').split(',');
        
        if( key === 'profile' ){
            
            setTimeout( ()=> {
                self.props.get_employee( user[1] );
                self.props.get_department();
                self.props.get_employee_list();
                self.props.get_designation();
                self.props.get_company();
            }, 800 );

        } else if( key === "summary" ) {
            this.props.get_summary_annual_leave( user[1] );
        }

    }

    render() {
        return (
            <div className="profile_wrapper">
                {/* <Row gutter={16}>
                    <Col span={24}>
                        <Link to={ '/requests/new/leave' }>
                            <Button 
                                type="primary"
                                icon={ 'solution' }
                                className="fl_right">Request Leave</Button>
                        </Link>
                    </Col>
                </Row> */}
                <Row gutter={16}>
                    <Col span={24}>
                        <Tabs defaultActiveKey="2" onChange={ this.handleTabs }>
                            <TabPane tab="Summary" key="summary">
                                <Summary data={ this.state.summary_data } />
                                <RequestSummary data={ this.state.request_data } />
                            </TabPane>
                            <TabPane tab="Profile" key="profile">
                                <Row>

                                    <Col span={18}>
                                        <About 
                                            data={ this.state.data } 
                                            department_data={ this.state.department_data }
                                            employee_data={ this.state.employee_data }
                                            designation_data={ this.state.designation_data }
                                            company_data={ this.state.company_data }
                                            onSubmit={ this.handleSubmit }
                                            onBack={ this.handleBack } />
                                    </Col>
                                    <Col span={6}>
                                        <div className="profile">
                                            <div className="pic">
                                                <div className="img_thumb">
                                                    <div className="img_thumb_inner">
                                                        <img src={ (this.state.data.picture) ? this.state.data.picture : this.state.profile } /> 
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <input onChange={ this.handleProfilePic } style={{ width: '220px',margin: '10px auto' }} type="file" />

                                        </div>
                                    </Col>

                                </Row>
                                
                            </TabPane>
                        </Tabs>

                    </Col>

                </Row>
            </div>
        )
    }
}


function mapStatetoProps( state ){
    return {
        employeeedit: state.employeeedit,
        summary: state.summary
    }
}

export default connect( mapStatetoProps, { 
    get_summary_annual_leave,
    get_employee, get_department, get_employee_list, get_designation, 
    get_company, update_employee, upload_files, get_request_summary } )( Profile );



// WEBPACK FOOTER //
// ./src/pages/profile/index.js